// extracted by mini-css-extract-plugin
export default {"blockTitle":"styles_blockTitle__CUUEQ","title":"styles_title__p6Dds"};